import {css} from "@emotion/css";

export const styles = {
    canvas: (width: number) => css `
      canvas {
        width: ${width}%;
        height: auto;
      }
    `
}